import {all} from 'redux-saga/effects';
import {createFetchSagaLatest} from 'utils/sagas';

import {
  fetchMemberForDashboard as fetchMemberForDashboardAction,
  fetchUser as fetchUserAction,
  fetchMemberBookingSets as fetchMemberBookingSetsAction
} from './';

import {
  fetchMemberForDashboard,
  fetchUser,
  fetchMemberBookingSets
} from 'sdk/users';

function* userDetailSaga() {
  yield all([
    createFetchSagaLatest(
      fetchMemberForDashboardAction,
      fetchMemberForDashboard
    ),
    createFetchSagaLatest(fetchUserAction, fetchUser),
    createFetchSagaLatest(fetchMemberBookingSetsAction, fetchMemberBookingSets)
  ]);
}

export default userDetailSaga;
